import { mapMutationsFromTypes } from 'schepotin-vuex-helpers';
import * as types from './mutation-types';

export default {
    /**
     * Generates {@link https://vuex.vuejs.org/en/mutations.html | mutations} from
     * {@link https://vuex.vuejs.org/en/mutations.html#using-constants-for-mutation-types | mutation types}
     *
     * Documentation
     * {@link https://www.npmjs.com/package/schepotin-vuex-helpers#mapmutationsfromtypes | mapMutationsFromTypes}
     */
    ...mapMutationsFromTypes({
        types,
        excludes: [
            types.USER_CLEAR_INFO,
            types.USER_FILL_INFO,
        ],
    }),

    [types.USER_CLEAR_INFO](state) {
        state.id = null;
        state.name = null;
        state.username = null;
        state.email = null;
        state.password = null;
        state.passwordConfirmation = null;
        state.role = {
            id: null,
            title: null,
        };
        state.country = {
            id: null,
            title: null,
        };
        state.school = {
            id: null,
            title: null,
        };
        state.serial = null;
        state.address = null;
        state.enabled = null;
        state.locked = null;
        state.createdAt = null;

        state.courses = [];
    },

    [types.USER_FILL_INFO](state, payload) {
        state.id = payload.id;
        state.name = payload.name;
        state.username = payload.username;
        state.email = payload.email;
        state.role = {
            id: payload.role.id,
            title: payload.role.title,
        };
        state.country = {
            id: payload.country.id,
            title: payload.country.title,
        };
        state.defaultLanguage = {
            language: payload.default_language || 'en',
            direction: payload.default_direction || 'ltr',
        };
        state.school = payload.school === null ? null :
            {
                id: payload.school.id,
                title: payload.school.title,
                subscription_start_date: payload.school.subscription_start_date,
                subscription_period: payload.school.subscription_period,
            };
        state.serial = payload.serial;
        state.address = payload.address;
        state.enabled = payload.enabled;
        state.locked = payload.locked;
        state.createdAt = payload.created_at;

        payload.courses.forEach((item) => {
            state.courses.push({
                id: item.id,
                title: item.name_translation[0].translation,
                start: item.pivot.subscription_start_date,
                period: item.pivot.subscription_period,
                status: item.course_status === null ? '' : item.course_status.name,
            })
        });
    },
};



// WEBPACK FOOTER //
// ./src/store/modules/user/mutations.js